<template>
    <v-container grid-list-lg>
        <v-layout row wrap>
            <template v-if="questionarioModel">
                <dadosgerais :model="questionarioModel" :usuarioModel="usuarioModel" :usuarioAutorModel="usuarioAutorModel" :transportadoraModel="transportadoraModel"></dadosgerais>
                <dadossolicitacao :questionarioProp="questionarioModel" :transportadoraProp="transportadoraModel" :usuarioAutorProp="usuarioAutorModel"></dadossolicitacao>
                <arquivosapolice :model="questionarioModel" v-if="!getPermissao('ANALISA_SOLICITACAO') || questionarioModel.status.id != estatusComputed.statusEnum.PROCESSAMENTO"></arquivosapolice>
                <arquivospropostas :model="questionarioModel" v-if="!getPermissao('ANALISA_SOLICITACAO') || questionarioModel.status.id != estatusComputed.statusEnum.PROCESSAMENTO"></arquivospropostas>
                <arquivosoutros :model="questionarioModel" v-if="!getPermissao('ANALISA_SOLICITACAO') || questionarioModel.status.id != estatusComputed.statusEnum.PROCESSAMENTO"></arquivosoutros>
                <seguradoras ref="seguradoras" :model="questionarioModel" v-if="getPermissao('ANALISA_SOLICITACAO') && questionarioModel.status.id != estatusComputed.statusEnum.PROCESSAMENTO"></seguradoras>
                <parecer :model="questionarioModel" ref="parecerRef" v-if="getPermissao('ANALISA_SOLICITACAO') && questionarioModel.status.id != estatusComputed.statusEnum.PROCESSAMENTO"></parecer>
            </template>
            
            <v-btn v-if="getPermissao('TROCA_MENSAGENS') && chat.sessao"
              style="margin: 10px"
              color="secondary"
              dark fab fixed bottom right
              @click="abrirChatDialog()">
              <v-badge top left color="error">
                <template v-slot:badge v-if="chat.mensagensNaoVisualizadas > 0">
                  <span>{{chat.mensagensNaoVisualizadas}}</span>
                </template>
                <v-icon>chat</v-icon>
              </v-badge>
            </v-btn>

            <v-flex xs12>
                <v-btn flat to="/ListagemSolicitacoes" color="primary">Voltar</v-btn>
            </v-flex>

            <v-dialog v-model="chat.dialog.opened" scrollable max-width="700px" id="container1" ref="container1" style="overflow-y: auto;">
              
              <v-card id="container0" ref="container0" class="default-border">
                <v-card-title style="background-color: rgba(0, 172, 193, 0.9); padding-top: 1%; padding-bottom: 1%;">
                  <h2 class="white--text">Mensagens</h2>
                  <v-spacer></v-spacer>
                  <v-btn id="fecharChatBtn" @click="fecharChatDialog()" icon dark>
                    <v-icon>close</v-icon>
                  </v-btn>
                </v-card-title>

                <v-divider></v-divider>
                
                <v-card-text id="container2" ref="container2" style="padding-left: 5%; padding-right: 5%; padding-bottom: 0%; padding-top: 0%; overflow-y: auto; height: 350px">
                  <div v-if="chat.mensagens ? chat.mensagens.length == 0 : false">
                    <br>
                    <span>Digite uma mensagem para iniciar a conversa</span>
                  </div>
                  <v-flex xs12 v-for="mensagem in chat.mensagens" :key="mensagem.id">
                    <br>
                    <v-layout align-center align-content-center>
                      <v-spacer v-if="!mensagemDeTerceiro(mensagem)"></v-spacer>
                      <v-flex xs9 sm8>
                        <v-card flat :class="`default-border ${!mensagemDeTerceiro(mensagem) ? 'chat-mensagem-propria' : 'chat-mensagem-terceiro'}`">
                          <span :class="!mensagemDeTerceiro(mensagem) ? 'white--text' : ''">{{ mensagem.mensagem }} </span>
                        </v-card>
                        <span class="chat-mensagem-descricao">{{`${customFormatComputed.localDateTimeToFormattedString(mensagem.dataEnvio)} - ${exibirNomeRemetenteChat(mensagem.usuarioRemetente) ? mensagem.usuarioRemetente.nome : 'Apisul Seguros'}`}}</span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-card-text>

                <v-card-actions style="padding-left: 5%; padding-right: 5%;">
                  <v-layout v-if="sessaoAbertaChat" align-center align-content-center>
                    <v-flex xs11 text-xs-center>
                      <textarea class="chat-mensagem-input" v-model="chat.dialog.novaMensagem"></textarea>
                      <span v-if="!novaMensagemValida && chat.dialog.houveValidacao" class="chat-mensagem-invalida">O campo deve ter entre 1 e 500 caracteres</span>
                    </v-flex>
                    <v-spacer></v-spacer>
                    <v-flex x1 text-xs-center>
                      <v-btn id="enviarMensagemBtn" :disabled="!novaMensagemValida || !sessaoAbertaChat || chat.enviando" :loading="chat.enviando" icon flat @click="sendMensagem(chat.dialog.novaMensagem)">
                        <v-icon color="secondary">send</v-icon>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-card-actions>
              </v-card>

            </v-dialog>

        </v-layout>
    </v-container>
</template>

<script>
import dadosgerais from '@/components/pages/solicitacao-consulta/DadosGerais'
import dadossolicitacao from '@/components/pages/solicitacao-consulta/DadosSolicitacao'
import dadoscadastrais from '@/components/pages/solicitacao-consulta/DadosCadastrais'
import dadosoperacionais from '@/components/pages/solicitacao-consulta/DadosOperacionais'
import segurosanteriores from '@/components/pages/solicitacao-consulta/SegurosAnteriores'
import novoseguro from '@/components/pages/solicitacao-consulta/NovoSeguro'
import seguradoras from '@/components/pages/solicitacao-consulta/Seguradoras'
import parecer from '@/components/pages/solicitacao-consulta/Parecer'
import arquivosapolice from '@/components/pages/solicitacao-consulta/ArquivosApolice'
import arquivospropostas from '@/components/pages/solicitacao-consulta/ArquivosPropostas'
import arquivosoutros from '@/components/pages/solicitacao-consulta/ArquivosOutros'
import cipher from '@/helpers/cipher'
import permissoes from '@/helpers/permissoes.js'
import axios from 'axios'
import usuarioHelper from '@/helpers/usuario-logado'
import EStatus from '@/helpers/estatus.js'
import Stomp from "webstomp-client"
import CustomFormat from '@/helpers/custom-format'
import formRules from '@/helpers/form-rules'

export default {
  name: 'solicitacaoconsulta',
  components: {
    dadosgerais,
    dadossolicitacao,
    dadoscadastrais,
    dadosoperacionais,
    segurosanteriores,
    novoseguro,
    seguradoras,
    parecer,
    arquivosapolice,
    arquivospropostas,
    arquivosoutros
  },
  data: () => {
    return {
      mapaPermissoes: null,
      pdf: null,
      questionarioModel: null,
      transportadoraModel: null,
      usuarioModel: null,
      usuarioAutorModel: null,
      nomeTransportadora: '',
      stepAtual: 1,
      stompClient: null,
      chat: {
        sessao: null,
        mensagens: null,
        mensagensNaoVisualizadas: 0,
        dialog: {
          opened: false,
          novaMensagem: '',
          houveValidacao: false
        },
        enviando: false
      }
    }
  },
  computed: {
    estatusComputed: function() {
      return EStatus;
    },
    customFormatComputed: function() {
      return CustomFormat;
    },
    formRulesComputed: function() {
      return formRules;
    },
    sessaoAbertaChat: function() {
      const self = this;
      if (self.chat.sessao) {
        return self.chat.sessao.aberta;
      } else {
        return false;
      }
    },
    novaMensagemValida: function() {
      const self = this;

      if (self.chat && !self.chat.dialog.houveValidacao && self.chat.dialog.novaMensagem.length > 0) {
        self.chat.dialog.houveValidacao = true;
      }

      if (self.chat && self.chat.dialog.novaMensagem.length > 0 && self.chat.dialog.novaMensagem.length <= 500) {
        return true;
      } else {
        return false;
      }
    }
  },
  mounted: async function () {
    this.mapaPermissoes = permissoes.getMapaPermissoes();
    await this.carregaQuestionario();
  },
  methods: {
    carregaQuestionario: async function () {
      const self = this;
      self.$store.commit('startLoading');
      await axios.get(`${process.env.URL_QUESTIONARIOMS}/v1/buscaQuestionario?id=${cipher.decrypt(self.$route.params.id)}`,
      {
        headers: {
          'Authorization': `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
        }
      })
      .then((response) => {
        self.questionarioModel = response.data;
      })
      .then(() => {
        self.$store.commit('endLoading');
        this.connectChatSocket();
      });
    },
    setNomeTransportadora: function (val) {
      this.nomeTransportadora = val;
    },
    getPermissao: function(requerida) {
      const self = this;
      if (requerida) {
        if (self.mapaPermissoes) {
          return self.mapaPermissoes.get(requerida);
        }
      }
      return false;
    },

    //CHAT COMEÇA AQUI

    connectChatSocket: function() {
      const self = this;
      if (self.getPermissao('TROCA_MENSAGENS')) {
        const url = process.env.URL_CHAT_WEBSOCKET;
        self.stompClient = Stomp.client(url, {debug: false});
        self.stompClient.connect({}, self.onConnect, self.onErrorConnect);
      }
    },
    onConnect: function(connection) {
      const self = this;
      self.stompClient.subscribe(`${process.env.CHAT_TOPIC_SESSAO_REQUEST}/${cipher.encode(usuarioHelper.USUARIO_LOGADO().idUsuario + "/" + usuarioHelper.USUARIO_LOGADO().email + "/" + self.questionarioModel.id + "/" + self.questionarioModel.protocolo)}`, self.onSessaoRecebida);
      self.sendRequest();
    },
    sendRequest: function() {
      const self = this;
      const request = cipher.encode({
        token: {
          idQuestionario: self.questionarioModel.id,
          tokenUsuario: usuarioHelper.USUARIO_LOGADO().token,
          responseTopic: cipher.encode(usuarioHelper.USUARIO_LOGADO().idUsuario + "/" + usuarioHelper.USUARIO_LOGADO().email + "/" + self.questionarioModel.id + "/" + self.questionarioModel.protocolo),
          type: 'JOIN'
        }}, 60);
      self.stompClient.send(process.env.CHAT_SENDER_CHAT_REGISTER, request);
    },
    onSessaoRecebida: function(mensagem) {
      const self = this;
      self.chat.sessao = cipher.decode(mensagem.body, true);
      self.stompClient.unsubscribe(mensagem.headers);
      
      if (self.chat.sessao != 'Ingresso não autorizado') {
        axios.get(`${process.env.URL_CHATMS}/v1/mensagens/${self.chat.sessao.id}`, {
          headers: {
            'Authorization': `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        })
        .then((response) => {
          self.chat.mensagens = cipher.decode(response.data, true);
          self.chat.mensagensNaoVisualizadas = 0;
          self.chat.mensagens.forEach(mensagem => {
            if (!mensagem.visualizada && mensagem.idUsuarioRemetente != usuarioHelper.USUARIO_LOGADO().idUsuario && !self.chat.dialog.opened) {
              self.chat.mensagensNaoVisualizadas += 1;
            }
          });
          self.stompClient.subscribe(`${process.env.CHAT_TOPIC_CHAT_MENSAGENS}/${self.chat.sessao.id}`, self.onNovaMensagemChat);
        })
      }
    },
    onNovaMensagemChat: function(mensagem) {
      const self = this;
      let mensagemDecoded = cipher.decode(mensagem.body, true);

      let mensagemRepetida = false;
      self.chat.mensagens.forEach(mensagem => {
        if (mensagem.id == mensagemDecoded.id) mensagemRepetida = true;
      });

      if (!mensagemRepetida) {
        self.chat.mensagens.push(mensagemDecoded);

        if (mensagemDecoded.idUsuarioRemetente != usuarioHelper.USUARIO_LOGADO().idUsuario) {
          if (!self.chat.dialog.opened) {
            self.chat.mensagensNaoVisualizadas += 1;
          } else {
            self.visualizarMensagens();
          }
        } else {
          self.chat.enviando = false;
          self.chat.dialog.novaMensagem = '';
          self.chat.dialog.houveValidacao = false;
        }
      }
    },
    sendMensagem: function(mensagemText) {
      const self = this;
      let novaMensagem = {
        idChatSessao: self.chat.sessao.id,
        mensagem: mensagemText,
        tokenUsuario: usuarioHelper.USUARIO_LOGADO().token
      };
      self.stompClient.send(process.env.CHAT_SENDER_CHAT_MENSAGENS, cipher.encode({ token: novaMensagem }, 60), { Authorization: "token" });
      self.chat.enviando = true;
    },
    onErrorConnect: function(error) {
      const self = this;
      self.chat.enviando = false;
      setTimeout(self.connectChatSocket(), 100000);
    },
    visualizarMensagens: function() {
      const self = this;
      if (self.chat.mensagens.length > 0) {
        const sessao = {
          aberta: self.chat.sessao.aberta,
          dataInicio: null,
          id: self.chat.sessao.id,
          idQuestionario: self.chat.sessao.idQuestionario
        }

        axios.post(`${process.env.URL_CHATMS}/v1/mensagens/visualizar`, sessao, {
          headers: {
            'Authorization': `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        }).then((response) => {
          if (response.data) {
            self.chat.mensagensNaoVisualizadas = 0;
          }
        });
      }
    },
    abrirChatDialog: function() {
      const self = this;
      self.chat.dialog.opened = true;
      self.visualizarMensagens();
    },
    fecharChatDialog: function() {
      const self = this;
      self.chat.dialog.opened = false;
    },
    exibirNomeRemetenteChat: function(usuarioRemetente) {
      const self = this;
      if (self.getPermissao('ANALISA_SOLICITACAO') || usuarioHelper.USUARIO_LOGADO().idUsuario == usuarioRemetente.id) {
        return true;
      } else {
        if (usuarioRemetente) {
          return permissoes.usuarioTemPermissao(usuarioRemetente, permissoes.SolicitacaoConsulta.ANALISA_SOLICITACAO) ? false : true;
        } else {
          return false;
        }
      }
    },
    mensagemDeTerceiro: function(mensagem) {
      if (mensagem) {
        return mensagem.usuarioRemetente.id != usuarioHelper.USUARIO_LOGADO().idUsuario;
      } else {
        return null;
      }
    }

    //CHAT TERMINA AQUI
  }
}
</script>

<style>
@import "../../../css/chat.css";

.overflow-label label {
  overflow: initial;
}

.lista-inconsistencias .list__tile {
  height: 100%;
  min-height: 72px;
  padding-top: 20px;
  padding-bottom: 20px;
}

.dropzone .dz-preview {
  width: 100% !important;
  margin: 0 !important;
}

.vue-dropzone .dz-preview .dz-details {
  background: #fff !important;
  color: #00456E !important;
}

.dropzone .dz-preview .dz-progress {
  margin-left: 0px !important;
  left: 9% !important;
  width: 80% !important;
  border: 1px solid #00456E !important;
}

.vue-dropzone .dz-preview .dz-remove {
  opacity: 1 !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  font-family: 'Roboto', sans-serif !important;
  border-radius: 3px !important;
  border: none !important;
  color: #00456E !important;
  letter-spacing: inherit !important;
  margin-left: 0px !important;
}

.vue-dropzone .dz-preview .dz-remove:hover {
  text-decoration: none !important;
  background: #00456E1a !important;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1) !important;
}

.dz-error-message, .dz-success-mark, .dz-error-mark {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/solicitacao-consulta/SolicitacaoConsulta.vue